import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Grid from "@material-ui/core/Grid";
import Loader from "../../components/Loader";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import {
  PROJECT,
  VILLAGES,
  USERS,
  DISTRICTS,
  SUB_DISTRICTS,
} from "../../configs/urls";
import { ROLES } from "../../configs/constant";
import Icon from "@material-ui/core/Icon";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { postApi, getApi, putApi } from "../../services/api";
import useForm from "../../formValidator/userForm";
import { Multiselect } from "multiselect-react-dropdown";
import RemoveIcon from "@material-ui/icons/Remove";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import AdminNavbarLinks from "../../components/Navbars/AdminNavbarLinks.js";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import classNames from "classnames";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import Toaster from "../../components/Toaster";

const navBarStyles = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: 120,
  },
  marginTop16: {
    marginTop: 16,
    width: "100%",
  },
  marginTop25: {
    marginTop: 25,
  },
  singleSelect: {
    width: "100%",
    marginTop: 19,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  fieldSupervisorsTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#777",
    display: "inline",
    textTransform: "uppercase",
  },
  opacity1: {
    opacity: 1,
  },
}));

const multiselectStyle = {
  searchBox: {
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};

export default function ProjectOperations(props) {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);
  const [submitButtonText, setSubmitButtonText] = useState("Add Project");
  const [action, setAction] = useState("add");
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);

  const [villagesList, setVillagesList] = useState([]);
  const [districtsList, setDistrictsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [orignalUsersList, setOrignalUsersList] = useState([]);

  const [fieldSupervisorsData, setFieldSupervisorsData] = useState([
    {
      id: "",
      villages: [],
    },
  ]);

  const [startDate, handleStartDateChange] = useState(new Date());
  const [endDate, handleEndDateChange] = useState(new Date());
  const [
    canShowcanShowConfirmationBoxBeforeGoBack,
    setCanShowcanShowConfirmationBoxBeforeGoBack,
  ] = useState(false);
  const history = useHistory();
  const navBarClasses = navBarStyles();

  const { color } = props;

  const appBarClasses = classNames({
    [" " + navBarClasses[color]]: color,
  });

  const goBack = () => {
    // if(!(JSON.stringify(params) == JSON.stringify(initialParams))) {
    //   setCanShowcanShowConfirmationBoxBeforeGoBack(true)
    // } else {
    // }
    history.goBack();
  };

  const validate = (values) => {
    let errors = {};

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!startDate) {
      errors.start_date = "Start date is required";
    }

    if (!endDate) {
      errors.end_date = "End date is required";
    }

    if (!values.crop_name) {
      errors.crop_name = "Crop name is required";
    }

    if (!values.target_in_tonnes) {
      errors.target_in_tonnes = "Target in tonnes is required";
    }

    if (!selectedDistricts || selectedDistricts.length === 0) {
      errors.district = "District is required";
    }

    return errors;
  };

  const handleConfirmConfirmationBoxClose = (action) => {
    if (action === "ok") {
      setCanShowcanShowConfirmationBoxBeforeGoBack(false);
      params.draft = 1;
      saveProject();
    } else {
      setCanShowcanShowConfirmationBoxBeforeGoBack(false);
    }
  };

  const isValidDates = () => {
    let isDateValid = true;

    let end_timestamp = new Date(endDate).getTime();

    let start_timestamp = new Date(startDate).getTime();

    if (end_timestamp < start_timestamp) {
      isDateValid = false;
    }

    return isDateValid;
  };

  const saveProject = (isDraft) => {
    if (!isValidDates()) {
      Toaster.showWarning("End date should be greater then start date.");
      return;
    }
    setIsRequestig(true);

    params.start_date = startDate.toISOString();
    params.end_date = endDate.toISOString();

    // params.field_supervisors = [];

    // fieldSupervisorsData.forEach((data, idx) => {
    //   let villagesIds = [];

    //   if (data.villages.length > 0) {
    //     villagesIds = data.villages.map(function (obj) {
    //       return obj.id;
    //     });
    //   }

    //   if (data.id && villagesIds.length > 0) {
    //     params.field_supervisors.push({
    //       id: data.id,
    //       villages: villagesIds,
    //     });
    //   }
    // });
    params.district_id = selectedDistricts.map((district) => district.id);
    if (props.match && props.match.params && props.match.params.project_id) {
      params.id = props.match.params.project_id;

      delete params.field_supervisors;
      params.district_id = 12;
      // selectedDistricts.map((district) => district.id);

      putApi(PROJECT, params)
        .then(
          (res) => {
            props.history.push("/admin/project");
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequestig(false);
        });
    } else {
      postApi(PROJECT, params)
        .then(
          (res) => {
            props.history.push("/admin/project");
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          setIsRequestig(false);
        });
    }
  };

  const selectSubDistrict = (subDistricts) => {
    var subDistrictIds = [];

    subDistricts.forEach((item) => {
      subDistrictIds.push(item.id);
    });

    setVillagesList([]);

    setIsRequestig(true);

    getApi(VILLAGES, {
      district_id: params.district_id,
      sub_district_ids: subDistrictIds,
    })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const getVillages = (e, value) => {
    let sub_district_id = "";

    if (e != null) {
      handleChange(e);
      sub_district_id = e.target.value;
    } else {
      sub_district_id = value;
    }

    setVillagesList([]);

    const items = [
      {
        id: "",
        villages: [],
      },
    ];

    setFieldSupervisorsData(items);

    setIsRequestig(true);

    getApi(VILLAGES, { district_id: params.district_id, sub_district_id })
      .then(
        (res) => {
          setVillagesList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const getSubDistrict = (e, value) => {
    let district_id = "";

    if (e != null) {
      handleChange(e);
      district_id = e.target.value;
    } else {
      district_id = value;
    }

    setSubDistrictList([]);

    setVillagesList([]);

    const items = [
      {
        id: "",
        villages: [],
      },
    ];

    setFieldSupervisorsData(items);

    setIsRequestig(true);

    getApi(SUB_DISTRICTS, { district_id })
      .then(
        (res) => {
          setSubDistrictList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const { params, errors, handleChange, handleSubmit } = useForm(
    saveProject,
    validate
  );
  const [initialParams, setInitialParams] = useState(
    JSON.parse(JSON.stringify(params))
  );

  const handleUserChange = (e, idx) => {
    let items = [...fieldSupervisorsData];

    let item = { ...items[idx] };

    item.id = e.target.value;

    items[idx] = item;

    setFieldSupervisorsData(items);
  };

  const handleVillagesChange = (list, idx) => {
    let items = [...fieldSupervisorsData];

    let item = { ...items[idx] };

    item.villages = list;

    items[idx] = item;

    setFieldSupervisorsData(items);
  };

  const addRemoveFieldFromFieldSuperVisorData = (action, idx) => {
    let items = [...fieldSupervisorsData];

    if (action === "add") {
      items.push({
        id: "",
        villages: [],
      });
    } else {
      items.splice(idx, 1);
    }

    setFieldSupervisorsData(items);
  };

  const getDynamicUserList = (
    list,
    currentSelectedList,
    currentSelectedUserId
  ) => {
    let updatedUserList = [];
    let userIds = [];

    currentSelectedList.forEach((value, key) => {
      userIds.push(value.id);
    });

    list.forEach((user, key) => {
      if (userIds.indexOf(user.id) === -1) {
        updatedUserList.push(user);
      } else {
        if (user.id == currentSelectedUserId) {
          updatedUserList.push(user);
        }
      }
    });

    return updatedUserList;
  };

  const getDynamicVillageList = (
    list,
    currentSelectedList,
    currentSelectedVillageIds
  ) => {
    let updatedVillageList = [];
    let villageIds = [];

    currentSelectedList.forEach((fieldSupervisor, idx) => {
      currentSelectedList[idx].villages.forEach((value, key) => {
        villageIds.push(value.id);
      });
    });

    list.forEach((village, key) => {
      if (villageIds.indexOf(village.id) == -1) {
        updatedVillageList.push(village);
      } else {
        if (currentSelectedVillageIds.indexOf(village) != -1) {
          updatedVillageList.push(village);
        }
      }
    });

    return updatedVillageList;
  };

  const renderFieldSuperVisorFields = (fieldSupervisor, idx) => {
    const dynamicUserList = getDynamicUserList(
      usersList,
      fieldSupervisorsData,
      fieldSupervisorsData[idx].id
    );
    const dynamicVillageList = getDynamicVillageList(
      villagesList,
      fieldSupervisorsData,
      fieldSupervisorsData[idx].villages
    );

    return (
      <GridContainer key={idx}>
        <GridItem xs={12} sm={12} md={4}>
          <FormControl
            variant="outlined"
            className={(classes.formControl, classes.singleSelect)}
          >
            <InputLabel id="field-superVisor-select-outlined-label">
              Field Supervisor
            </InputLabel>
            <Select
              labelId="field-superVisor-select-outlined-label"
              id="field-superVisor-select-outlined"
              name="ownership"
              value={fieldSupervisorsData[idx].id}
              onChange={(e) => handleUserChange(e, idx)}
              label="Field Supervisor"
            >
              {dynamicUserList.map((user, idx) => (
                <MenuItem key={idx} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        <GridItem xs={12} sm={12} md={7}>
          <Multiselect
            disable={dynamicVillageList == 0}
            options={dynamicVillageList}
            selectedValues={fieldSupervisorsData[idx].villages}
            onSelect={(selectedList, selectedItem) =>
              handleVillagesChange(selectedList, idx)
            }
            placeholder="Select Villages"
            style={multiselectStyle}
            onRemove={(selectedList, removedItem) =>
              handleVillagesChange(selectedList, idx)
            }
            displayValue="name"
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={1}>
          {fieldSupervisorsData.length == idx + 1 &&
            (dynamicUserList.length > 0 || dynamicVillageList.length > 0) &&
            usersList.length > fieldSupervisorsData.length && (
              <IconButton
                edge="end"
                aria-label="delete"
                className={classes.marginTop25}
                onClick={() => addRemoveFieldFromFieldSuperVisorData("add")}
              >
                <Icon>add_circle</Icon>
              </IconButton>
            )}
          {fieldSupervisorsData.length != idx + 1 && (
            <IconButton
              edge="end"
              aria-label="delete"
              className={classes.marginTop25}
              onClick={() =>
                addRemoveFieldFromFieldSuperVisorData("remove", idx)
              }
            >
              <RemoveIcon />
            </IconButton>
          )}
        </GridItem>
      </GridContainer>
    );
  };

  useEffect(() => {
    setIsRequestig(true);

    const districts = getApi(DISTRICTS, { state_id: 1 });
    const users = getApi(USERS, {
      role: ROLES.FIELD_SUPERVISOR,
      idle_users: true,
    });

    let project = null;
    if (props.match && props.match.params && props.match.params.project_id) {
      project = getApi(PROJECT + "/" + props.match.params.project_id);
      setSubmitButtonText("Update Project");
      setAction("edit");
    }

    axios
      .all([users, districts, project])
      .then((res) => {
        if (res[0] && res[0].data) {
          setUsersList(res[0].data);
          setOrignalUsersList(res[0].data);
        }

        if (res[1] && res[1].data) setDistrictsList(res[1].data);

        if (res[2] && res[2].data) {
          const projectData = res[2].data;

          params.name = projectData.name;
          params.crop_name = projectData.crop_name;
          params.target_in_tonnes = projectData.target_in_tonnes;
          params.start_date = new Date(projectData.start_date);
          params.end_date = new Date(projectData.end_date);
          handleStartDateChange(new Date(projectData.start_date));
          handleEndDateChange(new Date(projectData.end_date));
          // selectedDistricts
          setSelectedDistricts(
            projectData.project_district.map((item) => item.district)
          );
          params.district_id = projectData.district_id;

          if (params.district_id) getVillages(null, params.district_id);

          const items = [];

          if (projectData.field_supervisors.length > 0) {
            projectData.field_supervisors.forEach((fieldSupervisor) => {
              let villagesData = [];
              let userId = "";
              if (fieldSupervisor.villages.length > 0) {
                fieldSupervisor.villages.forEach((village) => {
                  villagesData.push(village.village);
                });
              }

              if (
                fieldSupervisor.user_details &&
                fieldSupervisor.user_details.id
              )
                userId = fieldSupervisor.user_details.id;

              items.push({
                id: userId,
                villages: villagesData,
              });
            });
          }

          if (items.length === 0) {
            items.push({
              id: "",
              villages: [],
            });
          }

          setFieldSupervisorsData(items);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  }, []); //eslint-disable-line

  return (
    <>
      <AppBar className={navBarClasses.appBar + appBarClasses}>
        <Toolbar className={navBarClasses.container}>
          <div className={navBarClasses.flex}>
            {/* Here we create navbar brand, based on route name */}
            <Button
              color="transparent"
              onClick={() => goBack()}
              className={navBarClasses.title}
              startIcon={<ArrowBackIosIcon />}
            >
              Create / Manage project
            </Button>
          </div>
          <Hidden smDown implementation="css">
            <AdminNavbarLinks />
          </Hidden>
          <Hidden mdUp implementation="css">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        <Loader isLoading={isRequesting} />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <form noValidate onSubmit={handleSubmit}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>{}</h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Name"
                        name="name"
                        autoFocus
                        value={params.name || ""}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <Box color="secondary.main">{errors.name}</Box>
                      )}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="crop_name"
                        label="Crop name"
                        name="crop_name"
                        autoFocus
                        value={params.crop_name || ""}
                        onChange={handleChange}
                      />
                      {errors.crop_name && (
                        <Box color="secondary.main">{errors.crop_name}</Box>
                      )}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        type="number"
                        id="target_in_tonnes"
                        label="Target in tones"
                        name="target_in_tonnes"
                        autoFocus
                        value={params.target_in_tonnes || ""}
                        onChange={handleChange}
                      />
                      {errors.target_in_tonnes && (
                        <Box color="secondary.main">
                          {errors.target_in_tonnes}
                        </Box>
                      )}
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <KeyboardDatePicker
                        autoOk
                        className={classes.marginTop16}
                        variant="inline"
                        inputVariant="outlined"
                        label="Start Date"
                        format="DD/MM/YYYY"
                        value={startDate}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(date) => handleStartDateChange(date)}
                      />
                      {errors.start_date && (
                        <Box color="secondary.main">{errors.start_date}</Box>
                      )}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={4}>
                      <KeyboardDatePicker
                        autoOk
                        className={classes.marginTop16}
                        variant="inline"
                        inputVariant="outlined"
                        label="End Date"
                        format="DD/MM/YYYY"
                        value={endDate}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(date) => handleEndDateChange(date)}
                      />
                      {errors.end_date && (
                        <Box color="secondary.main">{errors.end_date}</Box>
                      )}
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    {/* <GridItem xs={12} sm={12} md={4}>
                      <FormControl
                        variant="outlined"
                        className={`${classes.formControl}, ${classes.singleSelect} ${action === "edit" || params.district_id == null ? classes.disable : ""}`}
                      >
                        <InputLabel id="district-simple-select-outlined-label">
                          Sub District
                        </InputLabel>
                        <Select
                          labelId="sub_district_id-simple-select-outlined-label"
                          id="sub_district_id-simple-select-outlined"
                          name="sub_district_id"
                          value={params.sub_district_id || ""}
                          onChange={(e) => getVillages(e)}
                          label="Sub District"
                        >
                          {subDistrictList.map((district, idx) => (
                            <MenuItem key={idx} value={district.id}>
                              {district.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </GridItem> */}
                    {/* <GridItem xs={12} sm={12} md={4}>
                      <FormControl
                        variant="outlined"
                        className={`${classes.formControl}, ${
                          classes.singleSelect
                        } ${action === "edit" ? classes.disable : ""}`}
                      >
                        <InputLabel id="district-simple-select-outlined-label">
                          District *
                        </InputLabel>
                        <Select
                          labelId="district-simple-select-outlined-label"
                          id="district-simple-select-outlined"
                          name="district_id"
                          value={params.district_id || ""}
                          onChange={(e) => getSubDistrict(e)}
                          label="District"
                        >
                          {districtsList.map((district, idx) => (
                            <MenuItem key={idx} value={district.id}>
                              {district.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {errors.district && (
                        <Box color="secondary.main">{errors.district}</Box>
                      )}
                    </GridItem> */}
                    <GridItem xs={12} sm={12} md={8}>
                      <Multiselect
                        placeholder="Select District"
                        displayValue="name"
                        style={multiselectStyle}
                        options={districtsList}
                        selectedValues={selectedDistricts || []}
                        onSelect={(selectedList) =>
                          setSelectedDistricts(selectedList)
                        }
                        onRemove={(selectedList) =>
                          setSelectedDistricts(selectedList)
                        }
                      />
                      {errors.district && (
                        <Box color="secondary.main">{errors.district}</Box>
                      )}
                    </GridItem>
                  </GridContainer>

                  {/* {action != "edit" && (
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.marginTop25}>
                          <h3 className={classes.fieldSupervisorsTitle}>
                            Add Field Supervisors
                          </h3>
                        </div>
                      </GridItem>
                    </GridContainer>
                  )}
                  {action != "edit"
                    ? fieldSupervisorsData.map((fieldSupervisor, idx) =>
                        renderFieldSuperVisorFields(fieldSupervisor, idx)
                      )
                    : null} */}
                </CardBody>
                <CardFooter>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                  >
                    <Button color="primary" type="submit">
                      {submitButtonText}
                    </Button>
                  </Grid>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
        <Dialog
          open={canShowcanShowConfirmationBoxBeforeGoBack}
          aria-labelledby="confirm-box-dialog-title"
          aria-describedby="confirm-box-dialog-description"
        >
          <DialogTitle id="confirm-box-dialog-title">
            {"Confirmation?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-box-dialog-description">
              There are some unsaved change. Would you like to draft them.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleConfirmConfirmationBoxClose("cancel")}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleConfirmConfirmationBoxClose("ok")}
              color="primary"
              autoFocus
            >
              Draft
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
